import React, { useContext, useEffect, useState } from 'react';
import { Button, Card, CardBody, CardHeader, Col, FormFeedback, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from 'reactstrap';
import CategoryList from '../InspectionForm/CategoryList';
import ComponentList from '../InspectionForm/ComponentList';
import TroubleshootList from '../InspectionForm/TroubleshootList';
import { deleteChecklistItem, getInspectionChecklists, updatetInspectionChecklistItem } from '../../../Actions/InspectionActs';
import { GlobalStore } from '../../../StateStores';
import CategoryManager from './CategoryManager';
import ComponentManager from './ComponentManager';
import TroubleshootManager from './TroubleshootManager';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';

const InspectionLogBookManager = ()=>{
    const [modal, setModal] = useState(false);
    const [form,setForm] = useState({el_value:'',});
    const [formErrors,setFormErrors] = useState({el_value:'Value is required',});
    const [formValid, setFormValid] = useState(false);
    const [categories, setCategories] = useState([]);
    const [inspectionMaster, setInspectionMaster] = useState({});
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedComponent, setSelectedComponent] = useState(null);

    useEffect(() => {
        const isValid = Object.values(formErrors).every(item => !item);
        setFormValid(isValid);
    }, [formErrors]);

    const togOpenModal = ()=>{
        setModal(!modal);
    }

    const {
        InspectionDispatch,
        InspectionState:{
            getInspections:{error,loading,data},
        },
        ChecklistManagerDispatch,
        ChecklistManagerState:{
            deleteChecklistItem:{
                error:deleteError,
                loading:deleteLoading,
                data:deleteData},
            editChecklistItem:{
                error:editError,
                loading:editLoading,
                data:editData},
        }} = useContext(GlobalStore);

    const loadChecklist = async ()=>{
        try {
            const response = await getInspectionChecklists({})(InspectionDispatch)
            const {checklist,master} = response.data;
            
            setCategories(checklist)
            setInspectionMaster(master[0])
        } catch (error) {
            
        }
    }

    useEffect(()=>{
        loadChecklist();
    },[])

    const refreshList = ()=>{
        loadChecklist();
    }

    const handleCategorySelect = (category) => {
        setSelectedCategory(category);
        setSelectedComponent(null);
    };
    
    const handleComponentSelect = (component) => {
        setSelectedComponent(component);
    };

    const onChange = ({name,value}) => {
        setForm((prev) => ({ ...prev, [name]: value }));
        if (value) {
            setFormErrors(prev => ({ ...prev, [name]: '' }));
        } else {
            setFormErrors(prev => ({ ...prev, [name]: 'This field is required' }));
        }
    }

    const onDeleteAction = (object)=>{
        
        Swal.fire({
            title: 'Are you sure?',
            text: `Do you want to delete - " ${object?.name} " ?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
          }).then(async (result) => {

            if (result.isConfirmed) {

                try {
                    //Fire the request for delete the checklist
                    await deleteChecklistItem(object)(ChecklistManagerDispatch)

                    Swal.fire(
                        'Deleted!',
                        `"${object?.name}" has been deleted.`,
                        'success'
                    );
                    
                } catch (error) {
                    Swal.fire(
                        'Error!',
                        'There was a problem deleting this item.',
                        'error'
                    );
                }

            }

          })
    }

    const onEditAction = async (object)=>{
        togOpenModal()
        setForm({
            ...form,
            ...object,
            action:'edit',
            el_value:object?.name});
    }

    const onCreateAction = async (object)=>{
        togOpenModal()
        setForm({
            ...form,
            ...object,
            action:'create',
            el_value:object?.name});
    }

    const onsubmit = async ()=>{
        try {
            const tesponse = await updatetInspectionChecklistItem(form)(ChecklistManagerDispatch);
            if(tesponse.status){
                toast.success(tesponse.message)
            }
        } catch (error) {
            toast.error(error?.message)
        }
    }

    return(
        <React.Fragment>

            <Modal size='md' isOpen={modal} scrollable={true} toggle={() => { togOpenModal() }}>
                <ModalHeader toggle={() => { togOpenModal() }}>Edit </ModalHeader>
                <ModalBody>
                    <Input
                    placeholder='Write group name'
                    value={form.el_value}
                    onChange={(e) => onChange({name:'el_value',value:e?.target?.value})}
                    valid={formErrors.el_value === ''}
                    invalid={formErrors.el_value !== ''}
                    />
                    {formErrors.el_value && <FormFeedback>{formErrors.el_value}</FormFeedback>}
                </ModalBody>
                <ModalFooter>
                    <Button
                    disabled={!formValid} 
                    onClick={onsubmit}
                    color="dark">
                        {editLoading && <Spinner size="sm"/> }
                        <span className='ms-1'>Save</span>
                    </Button>
                </ModalFooter>
            </Modal>

            <Card className="shadow-sm card-animated mt-5">
                <CardHeader tag="div" className='w-100'>
                    <div className='d-flex justify-content-between'>
                        <div>
                            <span className="ri-truck-line"></span>
                            <span className="ms-1">VEHICLE INSPECTION CHECKLIST MANAGER</span>
                        </div>
                        <div>
                            <Button 
                                size='sm' 
                                outline
                                onClick={refreshList}
                                >
                                {loading && <Spinner size="sm"/>}
                                {!loading && <span className="ri-refresh-line"></span>}
                            </Button>
                        </div>
                    </div>
                </CardHeader>
                <CardBody>
                <Row>
                    <Col>
                        <div className='d-flex justify-content-between p-1'>
                            <h5>System Categories</h5>
                            <Button 
                                size='sm' 
                                outline
                                onClick={(e)=>{
                                    onCreateAction({listgroup:'Category'})
                                }}
                                >
                                <span className="ri-add-fill"></span>
                            </Button>
                        </div>
                        <CategoryManager 
                            categories={categories} 
                            onSelectCategory={handleCategorySelect} 
                            activeCategory={selectedCategory} 
                            onEdit={onEditAction}
                            onDelete={onDeleteAction}
                        />
                    </Col>
                    <Col>
                        <div className='d-flex justify-content-between p-1'>
                            <h5>System Components</h5>
                            <Button 
                                size='sm' 
                                outline
                                onClick={(e)=>{
                                    onCreateAction({
                                        ...selectedCategory,
                                        listgroup:'Component'
                                    })
                                }}
                                >
                                <span className="ri-add-fill"></span>
                            </Button>
                        </div>
                        {selectedCategory ? (
                            <ComponentManager 
                            components={selectedCategory.components} 
                            onSelectComponent={handleComponentSelect} 
                            activeComponent={selectedComponent} 
                            onDelete={onDeleteAction}
                            onEdit={onEditAction}
                            />
                        ) : (
                            <p>Select a category to see components</p>
                        )}
                    </Col>
                    <Col>
                        <div className='d-flex justify-content-between p-1'>
                            <h5>Troubleshoots</h5>
                            <Button 
                                size='sm' 
                                outline
                                onClick={(e)=>{
                                    onCreateAction({
                                        ...selectedComponent,
                                        listgroup:'Troubleshoot'
                                    })
                                }}
                                >
                                <span className="ri-add-fill"></span>
                            </Button>
                        </div>
                        {selectedComponent ? (
                            <TroubleshootManager 
                            troubleshoots={selectedComponent.troubleshoots} 
                            componentName={selectedComponent.component_name}
                            componentId={selectedComponent.id}
                            onDelete={onDeleteAction}
                            onEdit={onEditAction}
                            />
                        ) : (
                            <p>Select a component to see troubleshoots and enter a report</p>
                        )}
                    </Col>
                </Row>
                </CardBody>
            </Card>
        </React.Fragment>
    )
}

export default InspectionLogBookManager;